import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import { Link } from '@latitude/link';
import { COLOR } from '@latitude/core/utils/constants';
import { Banner } from './index';
var staging = 'https://#branch-name#.staging.assets-latitude.digitalweb-np.lfscnp.com/web-content/banner/content.json';
var prod = 'https://assets.latitudefinancial.com/web-content/banner/content.json';
var bannerQueryString = 'bannerbranch';
var StyledLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "NotificationBanner__StyledLink",
  componentId: "sc-jahtq6-0"
})(["color:", "!important;&:hover{color:", "!important;text-decoration:none;}"], COLOR.WHITE, COLOR.WHITE);
export var NotificationBanner = function NotificationBanner(_ref) {
  var _ref$siteName = _ref.siteName,
      siteName = _ref$siteName === void 0 ? 'latitudefinancial-com-au' : _ref$siteName;

  var _useState = useState(null),
      message = _useState[0],
      setMessage = _useState[1];

  var _useState2 = useState(false),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var _useState3 = useState(false),
      isClose = _useState3[0],
      setIsClose = _useState3[1]; // Grab the data from the assets library


  useEffect(function () {
    if (typeof window !== 'undefined') {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var fetchUrl = urlParams.get(bannerQueryString) ? staging.replace('#branch-name#', urlParams.get(bannerQueryString)) : prod; // Access closeStatus from session storage

      var closeStatus = sessionStorage.getItem(siteName + '_closeStatus');

      if (closeStatus === true) {
        setIsClose(false);
      }

      fetch(fetchUrl).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data[siteName] && data[siteName]['isVisible'] && data[siteName]['message']) {
          setMessage(data[siteName]['message']);
          setIsVisible(true);
        }

        if (data[siteName]['isClose'] && !closeStatus) {
          setIsClose(true);
        }
      }).catch(function (err) {
        console.error('Unable to get banner content', err);
      });
    }
  }, []);

  var transform = function transform(node, index) {
    if (node.type === 'tag' && node.name === 'a') {
      return /*#__PURE__*/React.createElement(StyledLink, Object.assign({
        key: index,
        variant: COLOR.WHITE
      }, node.attribs['data-trackid'] ? {
        trackId: node.attribs['data-trackid']
      } : {}, {
        href: node.attribs.href,
        trackEventData: {
          location: 'banner'
        }
      }), node.children[0].data);
    }
  };

  if (!isVisible) {
    return null;
  }

  if (sessionStorage.getItem(siteName + '_closeStatus')) {
    setIsClose(false);
    setIsVisible(false);
  }

  var handleClose = function handleClose() {
    if (isClose) {
      setIsClose(false);
      setIsVisible(false);
      sessionStorage.setItem(siteName + '_closeStatus', true);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, isVisible && /*#__PURE__*/React.createElement(Banner, {
    onClose: isClose && handleClose,
    showClose: isClose
  }, ReactHtmlParser(message, {
    transform: transform
  })));
};